export default __webpack_public_path__ + "static/media/play-icon.16b8517e.svg";